
import { defineComponent, PropType } from 'vue'
import { maska } from 'maska'

import useValidationMessages from '@/common/composable/useValidationMessages'
import { ErrorObject } from '@vuelidate/core'

export default defineComponent({
    directives: {
        maska,
    },
    props: {
        name: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: null,
        },
        maska: {
            type: Object,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        isSuccess: {
            type: Boolean,
            default: false,
        },
        isWarning: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
        min: {
            type: String,
            default: null,
        },
        prefix: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value', 'change', 'focus', 'input'],
    setup(props, { emit }) {
        const emitInput = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('update:value', target.value)
            emit('input', event)
        }

        const emitChange = (event: Event) => {
            const target = event.target as HTMLInputElement
            emit('change', target.value)
        }

        const emitFocus = (event: Event) => {
            emit('focus', event)
        }

        const { getValidationMessage } = useValidationMessages()

        return { emitInput, emitChange, getValidationMessage, emitFocus }
    },
})
